<div class="col-md-10 offset-1">
  <br />
  <br />
  <h4>
    <b>{{data.sheetTitle}}</b>
  </h4>
  <br />
  <div [innerHTML]="data.sheetText">
  </div>
  <br />
  <br />
</div>

